/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterRoleDto } from '../../models/center-role-dto';

export interface CenterRoleControllerFindRoles$Params {

/**
 * 센터 ID
 */
  id: string;

/**
 * 소유자 역할 포함 여부
 */
  withOwnerRole?: boolean;
}

export function centerRoleControllerFindRoles(http: HttpClient, rootUrl: string, params: CenterRoleControllerFindRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterRoleDto>>> {
  const rb = new RequestBuilder(rootUrl, centerRoleControllerFindRoles.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('withOwnerRole', params.withOwnerRole, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterRoleDto>>;
    })
  );
}

centerRoleControllerFindRoles.PATH = '/api/center-role/{id}/roles';
